import Select from "react-select";
import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

import CustomModal from "../../../../utils/CustomModal/CustomModal";
import CustomDateTimePicker from "./../../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import ItemInfo from "../../../../utils/ItemInfo/ItemInfo";
import TooltipTitle from "../../../../utils/TooltipTitle/TooltipTitle";
import OnTypeSearch from "../../../../utils/OnTypeSearch/OnTypeSearch";
import UserAdminContext from "../../../../context/Admin/UserAdminContext/UserAdminContext";
import UserAdmin from "../../UserAdmin/UserAdmin";
import { orderAdminContext } from "../../../../context/Admin/OrderAdminContext/OrderAdminContext";
import {
  convertDate,
  formatToEnglishDate,
  numberSeparate,
} from "../../../../utils";
import { areYouSureMessage } from "../../../../utils/toastMessage/toastMessage";
import { ConvertCurrency } from "../../../../utils/Currency/Currency";

const Title = ({ data }) => {
  return (
    <div className="text-center">
      {data?.name && (
        <h2 className="fw-bold">{data?.name ?? data?.description}</h2>
      )}
      {data?.description_extra && <p>{data?.description_extra}</p>}
    </div>
  );
};

const EditOrderParams = ({ data }) => {
  const {
    values,
    admin_notification,
    setAdmin_notification,
    is_official_invoice,
    setIs_official_invoice,
    handleEditValues,
    handleGetOrder,
    isShowEditModal,
    handleShowEditModal,
    handleCloseEditModal,
  } = useContext(orderAdminContext);

  const renderParam = (_val) => {
    let render = null;

    switch (_val?.type) {
      case "radiobutton":
        render = <RadioButtonStep data={_val} />;
        break;
      case "text":
        render = <TextStep data={_val} />;
        break;
      case "multiplechoice":
        render = <MultipleChoiceStep data={_val} />;
        break;
      case "datetime":
        render = <DateTimeStep data={_val} />;
        break;
      case "number":
        render = <NumberStep data={_val} />;
        break;
      case "switch":
        render = <SwitchStep data={_val} />;
        break;
      case "item":
        render = <ItemStep data={_val?.values} />;
        break;

      default:
        render = null;
        break;
    }

    return <div>{render}</div>;
  };

  return (
    <>
      <button
        onClick={() =>
          handleGetOrder(data?.pk || data?.id, handleShowEditModal)
        }
        className="btn btn-primary mr-2"
      >
        ویرایش سفارش
      </button>

      {/* Start Edit Modal */}
      <CustomModal
        title="ویرایش"
        show={isShowEditModal}
        onHide={handleCloseEditModal}
        size="lg"
      >
        <div
          className="mb-2 px-2"
          style={{ maxHeight: 600, overflowY: "auto", overflowX: "hidden" }}
        >
          {/* Start User Section */}
          <UserSection isShowEditModal={isShowEditModal} />

          {/* End User Section */}
          {values?.map((_value) => (
            <>
              {renderParam(_value)}
              <hr />
            </>
          ))}

          {/* Start Admin Notification (Order Description) */}
          <div className="col-12">
            <label htmlFor="admin_notification">توضیحات اضافه سفارش</label>
            <textarea
              type="text"
              id="admin_notification"
              className="form-control"
              value={admin_notification}
              onChange={(e) => setAdmin_notification(e.target.value)}
              rows={7}
            />
          </div>
          <hr />
          {/* End Admin Notification (Order Description) */}

          {/* Official Invoice */}
          <div className="custom-control custom-switch mb-2">
            <input
              type="checkbox"
              className="custom-control-input"
              name="is_official_invoice"
              id="is_official_invoice"
              checked={is_official_invoice}
              onChange={(e) => setIs_official_invoice(e.target.checked)}
            />
            <label className="custom-control-label" for="is_official_invoice">
              فاکتور رسمی می خواهم
            </label>
          </div>
          <br />
        </div>

        <button
          className="btn btn-primary btn-block"
          onClick={() => handleEditValues(handleCloseEditModal)}
        >
          <i className="fas fa-check mr-2"></i>
          ویرایش
        </button>
      </CustomModal>
      {/* End Edit Modal */}
    </>
  );
};

export default EditOrderParams;

export const CreateOrder = () => {
  const {
    values,
    userSearch,
    setUserSearch,
    isUserLoading,
    client,
    setClient,
    services,
    users,
    setUsers,
    unique_id,
    setUnique_id,
    address_id,
    setAddress_id,
    isShowCreateModal,
    addresses,
    is_official_invoice,
    setIs_official_invoice,
    handleShowCreateModal,
    handleCloseCreateModal,
    handleGetService,
    handleCreateOrder,
    handleGetUsers,
    handleGetServices,
    handleGetAddresses,
  } = useContext(orderAdminContext);

  const permission = useSelector((state) => state.permission);

  const [isShowCreateUserModal, setIsShowCreateUserModal] = useState(false);

  const serviceOptions = services?.map((_value) => ({
    label: _value.name,
    value: _value.unique_id,
  }));

  const handleShowCreateUserModal = () => {
    setIsShowCreateUserModal(true);
  };
  const handleCloseCreateUserModal = () => {
    setIsShowCreateUserModal(false);
  };

  // Set State After Typing
  const onTypeUserSearch = OnTypeSearch(setUserSearch);

  useEffect(() => {
    if (isShowCreateModal && userSearch) handleGetUsers();
    else setUsers([]);
  }, [userSearch]);
  useEffect(() => {
    if (isShowCreateModal && isEmpty(services)) handleGetServices();
  }, [isShowCreateModal]);

  const renderParam = (_val) => {
    let render = null;

    switch (_val?.type) {
      case "radiobutton":
        render = <RadioButtonStep data={_val} />;
        break;
      case "text":
        render = <TextStep data={_val} />;
        break;
      case "multiplechoice":
        render = <MultipleChoiceStep data={_val} />;
        break;
      case "datetime":
        render = <DateTimeStep data={_val} />;
        break;
      case "number":
        render = <NumberStep data={_val} />;
        break;
      case "switch":
        render = <SwitchStep data={_val} />;
        break;
      case "item":
        render = <ItemStep data={_val?.values} />;
        break;

      default:
        render = null;
        break;
    }

    return <div>{render}</div>;
  };

  return (
    <>
      <button onClick={handleShowCreateModal} className="btn btn-success mr-2">
        <i className="fa fa-plus" /> افزودن
      </button>

      {/* Start Create Order Modal */}
      <CustomModal
        title="افزودن"
        show={isShowCreateModal}
        onHide={handleCloseCreateModal}
        size="lg"
      >
        <button
          onClick={handleShowCreateUserModal}
          className="btn btn-info mb-2"
        >
          <i className="fa fa-plus" /> افزودن کاربر
        </button>
        {/* Start Select User */}
        <form
          className="input-group position-relative mb-2"
          onSubmit={(e) => {
            handleGetUsers(e);
          }}
        >
          <input
            {...onTypeUserSearch}
            id="userSearch"
            name="userSearch"
            placeholder="جستجو کاربر"
            className="form-control"
            autocomplete="off"
          />
          <div className="input-group-append">
            <button className="btn btn-primary" type="submit">
              <i className="fa fa-search"></i>
            </button>
          </div>
          <div className="input-group-append">
            <button
              className="btn btn-secondary"
              onClick={() => {
                setTimeout(() => setUsers([]), 300);
                setUserSearch("");
              }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
        </form>

        {isUserLoading ? (
          <div className="text-center mt-2">
            <Spinner animation="grow" variant="success" />
          </div>
        ) : isEmpty(users) ? null : (
          <div className="position-relative">
            <div className="searchListAutoComplete">
              {users.map((_user) => (
                <div className="d-flex align-items-center">
                  <div
                    className="card border m-0 searchAutoCompleteCard col font-weight-bold"
                    onClick={() => {
                      setClient(_user);
                      setUsers([]);
                      handleGetAddresses(_user.pk);
                      setAddress_id("");
                    }}
                  >
                    <div className="p-2 d-flex justify-content-between">
                      <div>
                        {_user?.first_name} {_user?.last_name}
                      </div>
                      <div className="bg-white">
                        <TooltipTitle title="شماره موبایل">
                          <span>{_user?.mobile}</span>
                        </TooltipTitle>{" "}
                        -{" "}
                        <TooltipTitle title="شناسه">
                          <span>{_user?.pk}</span>
                        </TooltipTitle>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {!isEmpty(client) && (
          <div className="row mt-3">
            <ItemInfo label="نام">
              <p>{client?.first_name}</p>
            </ItemInfo>
            <ItemInfo label="نام خانوادگی">
              <p>{client?.last_name}</p>
            </ItemInfo>
            <ItemInfo label="شماره موبایل">
              <p>{client?.mobile}</p>
            </ItemInfo>
          </div>
        )}
        <hr />
        {isEmpty(client) ? (
          <p className="alert alert-info">
            برای افزودن آدرس ابتدا کاربر را انتخاب نمایید
          </p>
        ) : (
          <>
            {isEmpty(addresses) ? (
              <p className="alert alert-info">
                آدرسی برای کاربر {client.first_name} {client.last_name} یافت نشد
                از قسمت افزودن کاربر نسبت به ثبت آدرس برای کاربر اقدام نمایید
              </p>
            ) : (
              <>
                {addresses.map((adrs) => (
                  <label
                    htmlFor={adrs.id}
                    className="select_item"
                    key={adrs.id}
                  >
                    <span>
                      عنوان: <span className="text-primary">{adrs.title}</span>
                      <br />
                      آدرس: <span className="text-primary">{adrs.address}</span>
                    </span>
                    <input
                      type="radio"
                      checked={adrs.id === address_id}
                      onChange={() => setAddress_id(adrs.id)}
                      name="orderAddress"
                      id={adrs.id}
                    />
                  </label>
                ))}
              </>
            )}
          </>
        )}
        <hr />
        <div>
          <label>نوع سفارش</label>
          <Select
            openMenuOnFocus
            noOptionsMessage={() => <span>داده ای برای نمایش یافت نشد</span>}
            value={
              unique_id &&
              serviceOptions?.find((obj) => unique_id === obj.unique_id)
            }
            className="react-select-container"
            classNamePrefix="react-select"
            options={serviceOptions}
            placeholder="لطفا نوع سفارش را انتخاب نمایید"
            onChange={(e) => {
              const value = e?.value;
              handleGetService(value);
              setUnique_id(value);
            }}
          />
        </div>
        <hr />

        {/* End Select User */}
        {values?.map((_value) => (
          <>
            {renderParam(_value)}
            <hr />
          </>
        ))}
        {unique_id && permission.use_discount_check && (
          <>
            <hr />
            <Discount />
          </>
        )}

        {/* Official Invoice */}
        <div className="custom-control custom-switch mb-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="is_official_invoice"
            id="is_official_invoice"
            checked={is_official_invoice}
            onChange={(e) => setIs_official_invoice(e.target.checked)}
          />
          <label className="custom-control-label" for="is_official_invoice">
            فاکتور رسمی می خواهم
          </label>
        </div>
        <br />

        <button
          className="btn btn-primary btn-block"
          onClick={handleCreateOrder}
        >
          <i className="fas fa-check mr-2"></i>
          افزودن
        </button>
      </CustomModal>
      {/* End Create Order Modal */}

      {/* Start Create User Modal */}
      <CustomModal
        title="افزودن"
        show={isShowCreateUserModal}
        onHide={handleCloseCreateUserModal}
        size="xl"
      >
        <UserAdminContext
          setForcePhoneNumber={(val) => {
            document.getElementById("userSearch").value = val;
            setUserSearch(val);
          }}
        >
          <UserAdmin isNotPage />
        </UserAdminContext>
      </CustomModal>
      {/* End Create User Modal */}
    </>
  );
};

const RadioButtonStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  const list = data.list?.split("،");
  return (
    <div className="container">
      <Title data={data} />

      <select
        className="form-control"
        name={data?.parameter}
        onChange={(e) => handleEditValue(data, Number(e.target.value))}
      >
        <option selected value="" disabled hidden>
          لطفا یک گزینه را انتخاب کنید
        </option>
        {list?.map((_value, index) => (
          <option
            key={index + _value}
            selected={index === data?.value}
            value={index}
          >
            {_value}
          </option>
        ))}
      </select>
    </div>
  );
};

const TextStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  return (
    <div className="container">
      <Title data={data} />
      <div>
        <textarea
          className="form-control p-3"
          id={data.parameter}
          placeholder={data.description}
          value={data?.value}
          onChange={(e) => handleEditValue(data, e.target.value)}
          style={{ height: "30vh" }}
        />
      </div>
    </div>
  );
};

const MultipleChoiceStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  const list = data.list?.split("،");

  return (
    <div className="container">
      <Title data={data} />

      <select
        className="form-control"
        name={data?.parameter}
        onChange={(e) => handleEditValue(data, Number(e.target.value))}
      >
        <option selected value="" disabled hidden>
          لطفا یک گزینه را انتخاب کنید
        </option>
        {list?.map((_value, index) => (
          <option
            key={index + _value}
            selected={index === data?.value}
            value={index}
          >
            {_value}
          </option>
        ))}
      </select>
    </div>
  );
};

const DateTimeStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  return (
    <div className="container">
      <Title data={data} />
      <div>
        <label>تاریخ و ساعت</label>
        <CustomDateTimePicker
          type="single"
          placeholder="روز را انتخاب کنید"
          initValue={data?.value && new Date(formatToEnglishDate(data?.value))}
          onChange={(e) => {
            e && handleEditValue(data, convertDate(e, "YYYY-MM-DD HH:mm:ss"));
          }}
          todayBtn
          withTime
          autoClose={false}
          showTimeInput
        />
      </div>
    </div>
  );
};

const NumberStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  return (
    <>
      <div className="container">
        <Title data={data} />
        <div className="d-flex justify-content-center">
          <input
            type="number"
            name={data?.parameter}
            id={data?.parameter}
            className="form-control text-center w-25"
            value={data?.value}
            onChange={(e) => handleEditValue(data, Number(e.target.value))}
          />
        </div>
      </div>
    </>
  );
};

const SwitchStep = ({ data }) => {
  const { handleEditValue } = useContext(orderAdminContext);

  return (
    <>
      <div className="container">
        <Title data={data} />
        <div className="d-flex justify-content-center">
          <div className="custom-control custom-switch mb-2">
            <input
              type="checkbox"
              className="custom-control-input"
              name={data?.parameter}
              id={data?.parameter}
              checked={data?.value}
              onChange={(e) => handleEditValue(data, e.target.checked)}
            />
            <label className="custom-control-label" for={data?.parameter}>
              {data?.name}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

const ItemStep = ({ data }) => {
  const { values, setValues } = useContext(orderAdminContext);
  const [itemValues, setItemValues] = useState([]);

  useEffect(() => {
    setItemValues(data);
  }, []);

  useEffect(() => {
    // Set Values data
    if (!isEmpty(itemValues)) {
      let vals = [...values];
      let valIndex = vals?.findIndex((v) => v?.type === "item");
      let val = vals[valIndex];
      val.values = itemValues;
      vals[valIndex] = val;
      setValues(vals);
    }
  }, [itemValues]);

  // Change Switch And Number Value
  const handleChangeSwitchAndNumberValue = (val, paramItem, _valueId) => {
    const valuesArr = [...itemValues];

    // Search value changed input
    const paramIndex = valuesArr.findIndex((v) => v.id === _valueId);
    const param = valuesArr[paramIndex];

    // Serarch in values
    const valueIndex = param?.values?.findIndex(
      (v) => v.parameter === paramItem?.parameter
    );
    const value = param?.values[valueIndex];

    value.value = val;

    setItemValues(valuesArr);
  };

  const renderParam = (param, _valueId) => {
    let render = null;

    switch (param?.type) {
      case "switch":
        render = (
          <div className="custom-control custom-switch mb-2">
            <input
              type="checkbox"
              className="custom-control-input"
              name={param?.parameter}
              id={param?.parameter}
              checked={param?.value}
              onChange={(e) =>
                handleChangeSwitchAndNumberValue(
                  e.target.checked,
                  param,
                  _valueId
                )
              }
            />
            <label className="custom-control-label" for={param?.parameter}>
              {param?.name}
            </label>
          </div>
        );
        break;
      case "number":
        render = (
          <div className="text-center">
            <label htmlFor={param?.parameter}>
              <span className="fs-4" title={param?.description}>
                {param?.name}
              </span>
              <input
                type="number"
                name={param?.parameter}
                id={param?.parameter}
                className="form-control text-center"
                value={param?.value}
                min={param?.min}
                max={param?.max}
                onChange={(e) =>
                  handleChangeSwitchAndNumberValue(
                    Number(e.target.value),
                    param,
                    _valueId
                  )
                }
              />
            </label>
          </div>
        );
        break;
      case "radiobutton":
        const radioList = param?.list?.split("،");
        render = (
          <div className="container">
            <Title data={param} />

            <select
              className="form-control"
              name={param?.parameter}
              onChange={(e) =>
                handleChangeSwitchAndNumberValue(
                  Number(e.target.value),
                  param,
                  _valueId
                )
              }
            >
              <option selected={"" === param?.value} value={""} hidden>
                لطفا {param?.name ?? param?.description} را انتخاب نمایید
              </option>
              {radioList?.map((_value, index) => (
                <option
                  key={index + _value}
                  selected={index === param?.value}
                  value={index}
                >
                  {_value}
                </option>
              ))}
            </select>
          </div>
        );
        break;

      default:
        render = null;
        break;
    }
    return <>{render}</>;
  };

  return (
    <>
      <Title data={data} />
      {data?.map((_value, index) => (
        <div key={_value?.id}>
          {_value?.values?.map((_val) => (
            <div key={_val?.order + _val?.parameter}>
              {renderParam(_val, _value?.id)}
            </div>
          ))}
          <hr />
        </div>
      ))}
    </>
  );
};

const UserSection = ({ isShowEditModal }) => {
  const permission = useSelector((state) => state.permission);

  const {
    order,
    users,
    setUsers,
    userSearch,
    setUserSearch,
    isUserLoading,
    address,
    setAddress,
    isEditAddress,
    setIsEditAddress,
    coupon,
    setCoupon,
    handleGetUsers,
    handleEditUser,
    handleEditAddress,
    handleEditDiscount,
  } = useContext(orderAdminContext);

  const onTypeUserSearch = OnTypeSearch(setUserSearch);

  useEffect(() => {
    if (isShowEditModal && userSearch) handleGetUsers();
    else setUsers([]);
  }, [userSearch]);

  return (
    <>
      <form
        className="input-group position-relative mb-2"
        onSubmit={handleGetUsers}
      >
        <input
          {...onTypeUserSearch}
          id="userSearch"
          name="userSearch"
          placeholder="جستجو کاربر"
          className="form-control"
          autocomplete="off"
        />
        <div className="input-group-append">
          <button className="btn btn-primary" type="submit">
            <i className="fa fa-search"></i>
          </button>
        </div>
        <div className="input-group-append">
          <button
            className="btn btn-secondary"
            onClick={() => {
              setTimeout(() => setUsers([]), 300);
              setUserSearch("");
            }}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
      </form>

      {isUserLoading ? (
        <div className="text-center mt-2">
          <Spinner animation="grow" variant="success" />
        </div>
      ) : isEmpty(users) ? null : (
        <div className="position-relative">
          <div className="searchListAutoComplete">
            {users.map((_user) => (
              <div className="d-flex align-items-center">
                <div
                  onClick={() =>
                    areYouSureMessage(
                      () => handleEditUser(_user?.pk),
                      `آیا از ویرایش کاربر به ${_user?.first_name} ${_user?.last_name} ${_user?.mobile} اطمینان دارید؟`
                    )
                  }
                  className="card border m-0 searchAutoCompleteCard col font-weight-bold"
                >
                  <div className="p-2 d-flex justify-content-between">
                    <div>
                      {_user?.first_name} {_user?.last_name}
                    </div>
                    <div className="bg-white">
                      <TooltipTitle title="شماره موبایل">
                        <span>{_user?.mobile}</span>
                      </TooltipTitle>{" "}
                      -{" "}
                      <TooltipTitle title="شناسه">
                        <span>{_user?.pk}</span>
                      </TooltipTitle>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="row mt-3">
        <ItemInfo label="نام">
          <p>{order?.client?.first_name}</p>
        </ItemInfo>
        <ItemInfo label="نام خانوادگی">
          <p>{order?.client?.last_name}</p>
        </ItemInfo>
        <ItemInfo label="شماره موبایل">
          <p>{order?.client?.mobile}</p>
        </ItemInfo>
        <ItemInfo label="شناسه">
          <p>{order?.client?.pk}</p>
        </ItemInfo>
      </div>

      <hr />

      <form
        className="mb-2"
        onSubmit={(e) => {
          handleEditAddress(e);
        }}
      >
        <label htmlFor="address">آدرس</label>
        <div className="input-group">
          <input
            id="address"
            name="address"
            placeholder={order?.address?.address}
            className={`form-control ${isEditAddress ? "" : "bg-light"}`}
            autocomplete="off"
            value={address}
            disabled={!isEditAddress}
            readOnly={!isEditAddress}
            onChange={(e) => setAddress(e.target.value)}
          />
          {isEditAddress ? (
            <>
              <div className="input-group-append">
                <button className="btn btn-success" type="submit">
                  ثبت
                </button>
              </div>
              <div className="input-group-append">
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => {
                    setAddress(order?.address?.address);
                    setIsEditAddress(false);
                  }}
                >
                  لغو ویرایش
                </button>
              </div>
            </>
          ) : (
            <div className="input-group-append">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => setIsEditAddress(true)}
              >
                ویرایش
              </button>
            </div>
          )}
        </div>
      </form>

      <hr />

      {isEmpty(order?.discount?.title) ? (
        <>
          {permission.use_discount_check && (
            <form onSubmit={handleEditDiscount}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="کد تخفیف"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
                <div className="input-group-append">
                  <button
                    className={`btn ${
                      !coupon ? "btn-outline-primary disabled" : "btn-primary"
                    }`}
                    type="submit"
                    disabled={!coupon}
                  >
                    اعمال کد
                  </button>
                </div>
              </div>
            </form>
          )}
        </>
      ) : (
        <>
          <hr />
          <section>
            <p className="alert alert-success text-center">
              <span className="fw-bold">{order?.discount?.percent}</span> درصد
              تخفیف{" "}
              {order?.discount?.min_invoice_amount && (
                <span>
                  برای سفارشهایی با مبلغ حداقل{" "}
                  <ConvertCurrency
                    price={order?.discount?.min_invoice_amount}
                  />
                  ریال
                </span>
              )}{" "}
              تا سقف{" "}
              <ConvertCurrency price={order?.discount?.max_discount_amount} />{" "}
              ریال بر روی سفارش اعمال شده است
            </p>
            <p className="alert alert-primary text-center">
              عنوان: {order?.discount?.title}
              <br />
              کد تخفیف: {order?.discount?.ref_num}
              <hr />
              {order?.discount?.percent} مبلغ تخفیف:{" "}
              <ConvertCurrency price={order?.discount?.amount} />
              <br />
              درصد تخفیف: {order?.discount?.percent}%<br />
              حداقل مبلغ فاکتور{" "}
              <ConvertCurrency price={order?.discount?.min_invoice_amount} />
              <br />
              حداکثر میزان تخفیف:{" "}
              <ConvertCurrency price={order?.discount?.max_discount_amount} />
            </p>
          </section>
        </>
      )}
    </>
  );
};

const Discount = () => {
  const {
    coupon,
    setCoupon,
    couponInfo,
    handleCheckDiscount,
    handleResetCoupon,
  } = useContext(orderAdminContext);

  return (
    <>
      <p className="alert alert-primary text-center fw-bold">
        اگر کد تخفیفی دارید که مایل به استفاده از آن هستید، آن را وارد نمایید
      </p>
      {isEmpty(couponInfo) ? (
        <form onSubmit={handleCheckDiscount}>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="کد تخفیف"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
            />
            <button
              className={`btn btn${!coupon ? "-outline" : ""}-primary`}
              type="submit"
              disabled={!coupon}
            >
              اعمال کد
            </button>
          </div>
        </form>
      ) : (
        <>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="کد تخفیف"
              value={coupon}
              disabled
              readOnly
            />
            <button
              className="btn btn-danger"
              type="button"
              onClick={handleResetCoupon}
            >
              حذف کد تخفیف
            </button>
          </div>
          <p className="alert alert-success">
            <span className="fw-bold">{couponInfo.percent}</span> درصد تخفیف{" "}
            {couponInfo.min_invoice && (
              <span>
                برای سفارشهایی با مبلغ حداقل{" "}
                <span className="fw-bold">
                  {numberSeparate(couponInfo.min_invoice)}
                </span>{" "}
                تومان
              </span>
            )}{" "}
            تا سقف{" "}
            <span className="fw-bold">
              {numberSeparate(couponInfo.max_amount)} تومان
            </span>{" "}
            بر روی سفارش شما اعمال شد
          </p>
        </>
      )}
    </>
  );
};
